function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/@babel/runtime/helpers/iterableToArray.js
// module id = bOmF
// module chunks = 0471